import { Grid } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import TextAreaField from "@saleor/components/TextAreaField";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import { FormikProps } from "formik";
import React from "react";
import { useIntl } from "react-intl";

interface AdditionalTabProps {
  formik: FormikProps<any>;
  isViewMode: boolean;
}

const useStyles = makeStyles(
  theme => ({
    boxBackground: {
      borderRadius: 4,
      background: theme.palette.background.default,
      padding: "8px 16px",
      marginTop: 5,
      minHeight: 40
    },
    boxMinHeight: {
      minHeight: 100
    },
    // routeSearch: {
    //   display: "flex",
    //   alignItems: "center",
    //   gap: 10
    // },
    // routerInput: {},
    // routerBtn: {
    //   order: 1,
    //   height: 38
    // },
    // colorInfo: {
    //   color: theme.palette.info.dark,
    //   display: "inline",
    //   marginLeft: "3px"
    // },
    boxTextArea: {
      whiteSpace: "pre-line",
      lineBreak: "anywhere"
    },
    textarea: {}
  }),
  { name: "AdditionalTab" }
);

const AdditionalTab: React.FC<AdditionalTabProps> = props => {
  const { formik, isViewMode } = props;
  const classes = useStyles();
  const intl = useIntl();
  return (
    <Grid container spacing={6}>
      <Grid item xs={12} md={6}>
        <Grid item xs={12} md={12}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "Form Header"
            })}
            {/* <MyTypography variant={"subtitle3"} className={classes.colorInfo}>
              {intl.formatMessage({
                defaultMessage: "(CIP)"
              })}
            </MyTypography> */}
          </MyTypography>
          {isViewMode ? (
            <MyTypography
              variant={"body3"}
              className={classNames(
                classes.boxBackground,
                classes.boxMinHeight,
                classes.boxTextArea
              )}
            >
              {formik.values.formHeader ?? ""}
            </MyTypography>
          ) : (
            <TextAreaField
              maxLength={132}
              lineLimit={132}
              rowsMax={10}
              className={classes.textarea}
              name={"formHeader"}
              onBlur={formik.handleChange}
              onChange={() => null}
              rowsMin={3}
              value={formik.values.formHeader ?? ""}
              id="formHeader"
              data-testid="form-header-input"
            />
          )}
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          style={{ marginTop: "15px", marginBottom: "15px" }}
        >
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "Header Note 1"
            })}
            {/* <MyTypography variant={"subtitle3"} className={classes.colorInfo}>
              {intl.formatMessage({
                defaultMessage: "(CIP)"
              })}
            </MyTypography> */}
          </MyTypography>
          {isViewMode ? (
            <MyTypography
              variant={"body3"}
              className={classNames(
                classes.boxBackground,
                classes.boxMinHeight,
                classes.boxTextArea
              )}
            >
              {formik.values.headerNote1 ?? ""}
            </MyTypography>
          ) : (
            <TextAreaField
              maxLength={132}
              lineLimit={132}
              rowsMax={10}
              className={classes.textarea}
              name={"headerNote1"}
              onBlur={formik.handleChange}
              onChange={() => null}
              rowsMin={3}
              value={formik.values.headerNote1 ?? ""}
              id="headerNote1"
              data-testid="header-note1-input"
            />
          )}
        </Grid>
        <Grid item xs={12} md={12}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "Cash"
            })}
            {/* <MyTypography variant={"subtitle3"} className={classes.colorInfo}>
              {intl.formatMessage({
                defaultMessage: "(CIP)"
              })}
            </MyTypography> */}
          </MyTypography>
          {isViewMode ? (
            <MyTypography
              variant={"body3"}
              className={classNames(
                classes.boxBackground,
                classes.boxMinHeight,
                classes.boxTextArea
              )}
            >
              {formik.values.cash ?? ""}
            </MyTypography>
          ) : (
            <TextAreaField
              maxLength={132}
              lineLimit={132}
              rowsMax={10}
              name={"cash"}
              onBlur={formik.handleChange}
              onChange={() => null}
              rowsMin={3}
              value={formik.values.cash ?? ""}
              id="cash"
              data-testid="cash-input"
            />
          )}
        </Grid>
      </Grid>
      {/* <Grid item xs={12} md={6}>
        <Grid item xs={12} md={12}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "Internal Comments to Logistic"
            })}
            <MyTypography variant={"subtitle3"} className={classes.colorInfo}>
              {intl.formatMessage({
                defaultMessage: "(PP)"
              })}
            </MyTypography>
          </MyTypography>
          {isViewMode ? (
            <MyTypography
              variant={"body3"}
              className={classNames(
                classes.boxBackground,
                classes.boxMinHeight,
                classes.boxTextArea
              )}
            >
              {formik.values.internalCommentsToLogistic ?? ""}
            </MyTypography>
          ) : (
            <TextAreaField
              maxLength={132}
              lineLimit={132}
              rowsMax={10}
              className={classes.textarea}
              name={"internalCommentsToLogistic"}
              onBlur={formik.handleChange}
              onChange={() => null}
              rowsMin={3}
              value={formik.values.internalCommentsToLogistic ?? ""}
            />
          )}
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          style={{ marginTop: "15px", marginBottom: "15px" }}
        >
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "External Comments to Customer"
            })}
            <MyTypography variant={"subtitle3"} className={classes.colorInfo}>
              {intl.formatMessage({
                defaultMessage: "(PP)"
              })}
            </MyTypography>
          </MyTypography>
          {isViewMode ? (
            <MyTypography
              variant={"body3"}
              className={classNames(
                classes.boxBackground,
                classes.boxMinHeight,
                classes.boxTextArea
              )}
            >
              {formik.values.externalCommentsToCustomer ?? ""}
            </MyTypography>
          ) : (
            <TextAreaField
              maxLength={132}
              lineLimit={132}
              rowsMax={10}
              name={"externalCommentsToCustomer"}
              onBlur={formik.handleChange}
              onChange={() => null}
              rowsMin={3}
              value={formik.values.externalCommentsToCustomer ?? ""}
            />
          )}
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          style={{ marginTop: "15px", marginBottom: "15px" }}
        >
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "Internal Comments to Warehouse"
            })}
            <MyTypography variant={"subtitle3"} className={classes.colorInfo}>
              {intl.formatMessage({
                defaultMessage: "(PP)"
              })}
            </MyTypography>
          </MyTypography>
          {isViewMode ? (
            <MyTypography
              variant={"body3"}
              className={classNames(
                classes.boxBackground,
                classes.boxMinHeight,
                classes.boxTextArea
              )}
            >
              {formik.values.internalCommentsToWarehouse ?? ""}
            </MyTypography>
          ) : (
            <TextAreaField
              maxLength={132}
              lineLimit={132}
              rowsMax={10}
              name={"internalCommentsToWarehouse"}
              onBlur={formik.handleChange}
              onChange={() => null}
              rowsMin={3}
              value={formik.values.internalCommentsToWarehouse ?? ""}
            />
          )}
        </Grid>

        <Grid item xs={12} md={12}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({ defaultMessage: "Production information" })}
            <MyTypography variant={"subtitle3"} className={classes.colorInfo}>
              {intl.formatMessage({
                defaultMessage: "(PP)"
              })}
            </MyTypography>
          </MyTypography>
          {isViewMode ? (
            <MyTypography
              variant={"body3"}
              className={classNames(
                classes.boxBackground,
                classes.boxMinHeight,
                classes.boxTextArea
              )}
            >
              {formik.values.productInformation ?? ""}
            </MyTypography>
          ) : (
            <TextAreaField
              maxLength={132}
              lineLimit={132}
              rowsMax={10}
              name={"productInformation"}
              onBlur={formik.handleChange}
              onChange={() => null}
              rowsMin={3}
              value={formik.values.productInformation ?? ""}
            />
          )}
        </Grid>
      </Grid> */}
    </Grid>
  );
};

export default AdditionalTab;
